import React, { Component } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/styles';
import { createTheme } from '@mui/material/styles';
import { StyledEngineProvider } from '@mui/material';
import configureStore from './configureStore';
import ErrorGuard from './errors/ErrorGuard';
import ReactGA from 'react-ga';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { isTrackingEnabled } from './tracking.js';
import Root from './containers/Root';

const theme = createTheme();
const store = configureStore({});

if (isTrackingEnabled()) {
  ReactGA.initialize(window.runConfig.REACT_APP_GA_MEASUREMENT_ID);
}

class App extends Component {

  render() {
    return (
      <ErrorGuard>
        <Provider store={store}>
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
              <ToastContainer limit={3} position="bottom-right" />
                <CssBaseline />
                <Router basename="/">
                  <Root />
                </Router>
            </ThemeProvider>
          </StyledEngineProvider>
        </Provider>
      </ErrorGuard>
    );
  }
}

export default App;
